import classNames from "classnames";
import { FC, useMemo } from "react";

import Modal from "components/Modal";
import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";
import ModalCreateCompanyContent, { CompanyFormValues } from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  mode?: "create" | "edit";
  id?: number;
  initialData?: CompanyFormValues;
  callbackKey?: string;
};

const WidgetModalCreateCompany: FC<PropTypes> = ({
  isVisible,
  className,
  mode = "create",
  id,
  initialData,
  callbackKey,
}) => {
  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);
  const onSubmit = useMemo(() => callbacks?.onSave, [callbacks]);

  const isCreate = mode === "create";
  const title = isCreate ? "Create new company" : "Edit company";
  const description = isCreate ? "Enter company details and invite first user" : "Update company information";

  return (
    <Modal title={title} isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <ModalCreateCompanyContent
        id={id}
        mode={mode}
        onSubmit={onSubmit}
        description={description}
        initialData={initialData}
      />
    </Modal>
  );
};

export default WidgetModalCreateCompany;
